import { Link, Typography } from '@mui/material'
import TZG from 'assets/logos/tzg.svg'

export const TOP_ZINS_GARANTIE_HEADLINE = 'Top-Zins-Garantie'

export const TopZinsGarantieLogo = () => {
  return <img src={TZG} alt="Top Zins Garantie" height="56px" />
}

export const TopZinsGarantieContent = () => (
  <>
    <Typography variant="body2">
      Sie erhalten eine Einmalzahlung unter Nachweis, dass Sie über einen
      anderen Anbieter als FINANZCHECK einen günstigeren identischen Ratenkredit
      abschließen hätten können und dennoch Ihren Vertrag über FINANZCHECK
      abschließen. So unterbieten wir andere Anbieter und Sie zahlen garantiert
      nicht zu viel.
    </Typography>
    <br />
    <Typography variant="body2">
      Mehr über die Top-Zins-Garantie Bedingungen finden Sie{' '}
      <Link
        href="https://www.finanzcheck.de/lp/top-zins-garantie/"
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
      >
        hier
      </Link>
      .
    </Typography>
  </>
)
